




















































import { Component, Vue, Prop } from 'vue-property-decorator'

import { extend } from 'vee-validate'

import { SimpleLookupItem } from '@/models/SimpleLookupItem'
import { RetailInfo } from '@/models/RetailInfo'
import DropdownList from '@/components/form/DropdownList.vue'
import SelectPicker from '@/components/form/SelectPicker.vue'
import ToolTip from '@/components/form/ToolTip.vue'
import { LookupService } from '@/services/LookupService'

// Export Markets validation:
//   if export only or Aus and export then length of coutry or region must be greater than 0
//   if worldwide is selected then nothing else can be

extend('export', {
  params: [
    'countriesSold',
    'regionsSold'
  ],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validate(value: number, { countriesSold, regionsSold }: Record<string, any>): boolean {
      return value == 0 || (regionsSold.length > 0 || countriesSold.length > 0)
  },
  message: "You must select a region or a country if you export your products"
})

extend('exportWorldWide', {
  params: [
    'countriesSold'
  ],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validate(value: string[], { countriesSold }: Record<string, any>): boolean {
    return  value.includes('WW') ?
            (value.length === 1 && countriesSold.length === 0) :
            (value.length > 0 || countriesSold.length > 0)
  },
  message: "You can't select worldwide and other regions or countries"
})

@Component({
  components: {
    DropdownList,
    SelectPicker,
    ToolTip
  },
  name: 'ExportMarkets'
})
export default class ExportMarkets extends Vue {
  private lookupService= new LookupService()

 @Prop({required: true}) value!: RetailInfo

  get retailInfo(): RetailInfo {
    return this.value
  }
  set retailInfo(value: RetailInfo) {
    this.$emit('input', value)
  }

  countries: SimpleLookupItem[] = []
  regions: SimpleLookupItem[] = []

  created(): void {
    this.lookupService.GetRegions()
      .then((response) => {
        if (response !== null) {
          this.regions = response;
          return
        }
      })
      .catch((error) => {
        console.log(`Error retrieving Regions: ${error}`)
      })

    this.lookupService.GetCountries()
      .then((response) => {
        if (response !== null) {
          this.countries = response;
          return
        }
      })
      .catch((error) => {
        console.log(`Error retrieving Countries: ${error}`)
      })

  }
}
